import React from 'react';
import {motion} from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import {profile,facts,waLink} from '../data/content';

const {FiArrowUpRight,FiMessageCircle}=FiIcons;

function About() {
  return (
    <section className="pad" id="about">
      <div className="wrap about-grid">
        <motion.div
          className="about-portrait"
          initial={{opacity: 0,x: -24}}
          whileInView={{opacity: 1,x: 0}}
          viewport={{once: true}}
          transition={{duration: 0.6}}
        >
          <img
            src="https://media-manager-c.questera.ai/greta-media/328ccc7bfb8464cff28181f04d7e316c687ae1ee10dbf54c15208ba3627bd0db1bd72f93a9d5ca38120edb70dfec833b/images/aW1hZ2Uvd2VicA==/0f7e410462b72dcbc637a0744bd3c284.webp"
            alt="Syed, Full Stack Developer"
            loading="lazy"
          />
          <div className="about-badge"><span className="live-dot" /> {profile.role}</div>
        </motion.div>
        <motion.div
          className="about-copy"
          initial={{opacity: 0,x: 24}}
          whileInView={{opacity: 1,x: 0}}
          viewport={{once: true}}
          transition={{duration: 0.6}}
        >
          <span className="eyebrow">About me</span>
          <h2 className="h-section">Building the web, end to end — <span className="accent">with care.</span></h2>
          <p>I'm a <strong>Full Stack Developer</strong> based in {profile.location} with {profile.experience} of experience shipping production web apps. I'm equally comfortable crafting a React component, designing a normalized MySQL schema, or wiring up a PHP backend.</p>
          <p>My toolkit spans <strong>frontend</strong> (HTML, CSS, JavaScript, React), <strong>backend</strong> (Node.js, PHP) and <strong>databases</strong> (MySQL, MariaDB). I care about clean code, fast load times and interfaces that don't make people think.</p>
          <div className="about-facts">
            {facts.map((f)=> (
              <div className="fact" key={f.k}>
                <div className="k">{f.k}</div>
                <div className="v">{f.v}</div>
              </div>
            ))}
          </div>
          <a className="btn btn-whatsapp" href={waLink} target="_blank" rel="noreferrer">
            <SafeIcon icon={FiMessageCircle} /> Let's talk on WhatsApp <SafeIcon icon={FiArrowUpRight} />
          </a>
        </motion.div>
      </div>
    </section>
  );
}

export default About;
